import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteRatePlan } from 'modules/settings/api';

export const useMutationDeleteRatePlan = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation(deleteRatePlan, {
    onSuccess: () => {
      successToast(t('Rate plan successfully deleted'));
      queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_RATE_PLANS);
    },
    onError: () => errorToast(),
  });
};
